<template>
  <v-container fluid>
    <v-row class="px-0 py-0 my-0">
      <v-col cols="3">
        <RangeFilter
            :end="dateEnd"
            :start="dateStart"
            @getDates="getDates"
            :excludePeriod="[]"
            :defaultPeriod="4"
            :setDates="true"
            :disabled="loading"
        />
      </v-col>
    </v-row>
    <v-card class="elevation-2 px-2 mb-4 rounded-lg">
      <v-row class="px-4 pt-3 pb-6">
        <v-col cols="10" md="4" class="pb-0">
          <v-autocomplete
            v-model="selectedCampaign"
            :items="campaigns"
            item-text="name"
            item-value="id"
            label="Campaigns"
            outlined
            dense
            clearable
            hide-details
            class="text-body-2 text-capitalize mx-0 my-0 pr-0 pb-0"
          ></v-autocomplete>
          <v-spacer></v-spacer>
        </v-col>
        <v-col cols="10" md="4" class="pb-0">
          <v-text-field
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            outlined
          ></v-text-field>
        </v-col>
        <v-btn
          color="#3F51B5"
          class="mt-3"
          dark
          depressed
          height='40'
          max-width='40'
          min-width='40'
          @click="cleanFilters"
        >
          <v-icon>
            mdi-autorenew
          </v-icon>
        </v-btn>
      </v-row>
    </v-card>
    <v-data-table
        :search="search"
        :headers="headers"
        :items="dataFiltered"
        loading-text="Loading... Please wait"
        :loading="loading"
        item-key="id"
        show-expand
        class="elevation-1 table-main-container"
        fixed-header
        height="528"
        :page.sync="pagination.page"
        :footer-props="{
          'items-per-page-options': [5, 10, 25, 50, 75, 100, -1]
          }"
        >
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" style="word-break: break-all;">{{ JSON.stringify(item.payload) }}</td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import RangeFilter from '@/components/filters/RangePicker'

export default {
  components: {
    RangeFilter,
  },
  name: 'logs',
  data() {
    return {
      campaigns: [],
      selectedCampaign: null,
      search: '',
      loading: false,
      data: [],
      headers: [
          {text: 'Id', value: 'id', class: 'black--text'},
          {text: 'User Name', value: 'userName', class: 'black--text'},
          {text: 'Action', value: 'action', class: 'black--text'},
          {text: 'Campaign', value: 'campaign_name', class: 'black--text'},
          {text: 'Automated Mode', value: 'is_automated_mode', class: 'black--text'},
          {text: 'Date', value: 'date', class: 'black--text'}
        ],
      dataFiltered: [],
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1)).toISOString().substr(0, 10),
      pagination: {
        page: 1
      }
    }
  },
    mounted() {
    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }

    this.getLogs()
  },
  watch: {
    selectedCampaign: function (val) {
      this.filterData(val)
    },
    data(){
      this.pagination.page = 1
    }
  },
  methods: {
    filterData(val){
      if (val == null) {
        this.dataFiltered = this.data
        return
      }
      this.dataFiltered = this.data.filter(d => {
        return d.campaign_id == val
      })
    },
    getDates(dates) {
      this.dateStart = dates.dateStart
      this.dateEnd = dates.dateEnd
      this.pagination.page = 1
      this.getLogs()
    },
    getLogs() {
      this.loading = true
      axios
          .get(`/logs/${this.dateStart}/${this.dateEnd}`)
          .then(response => {
            this.data = response.data.data
            this.dataFiltered = this.data
            this.campaigns = this._.chain(this.data)
              .groupBy("campaign_id")
              .map((value, key) => ({id: key, name: value[0].campaign_name}))
              .value()
            this.loading = false
          })
    },

    cleanFilters() {
      this.search = ''
    }
  }
}

</script>
<style>
  .v-input--selection-controls__input {
    height: 13px !important;
  }
</style>
